import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ModalWrapper } from "@msuite/ui/modal";
import { cn } from "@msuite/ui/utils";
import { Fragment } from "react";
import { useTicketRules } from "@/hooks/use-ticket-rules";
import { AddTicketModal } from "@/modals/projects/add-ticket-modal/add-ticket-modal";

/** Props Interface */
interface AddTicketTriggerProps {
	projectId: string;
}

export function AddTicketTrigger({ projectId }: AddTicketTriggerProps) {
	/** Hooks */
	const addTicketModal = useDisclosure();
	const { t } = useTranslation();
	const { createIsDenied } = useTicketRules();

	/** Guard */
	if (createIsDenied(projectId)) return null;

	/** Render */
	return (
		<Fragment>
			<div
				onClick={addTicketModal.onOpen}
				onKeyUp={addTicketModal.onOpen}
				className={cn(
					"bg-transparent py-1 border-dashed w-max cursor-pointer card",
					"rounded-lg",
					"hover:opacity-90",
					"active:opacity-80",
					"flex flex-row gap-2 items-center",
				)}
			>
				<Icon
					name="Plus"
					className="text-primaryGray-500 text-sm"
				/>
				<p>{t("projects.add_ticket")}</p>
			</div>
			<ModalWrapper>
				{addTicketModal.isOpen && (
					<AddTicketModal
						isOpen={addTicketModal.isOpen}
						onClose={addTicketModal.onClose}
						projectId={projectId}
					/>
				)}
			</ModalWrapper>
		</Fragment>
	);
}
